<template>
  <div>
    <div v-if="!editMode">{{value|formatDateTime}}</div>
    <div v-if="editMode" class="row flex-nowrap">      
      <!-- {{dt}}        
      <b-form-datepicker v-model="dt" locale="sv" button-only v-if="editMode"></b-form-datepicker>-->
      <b-input-group class="mb-3">
        <datepicker v-if="editMode" v-model="dt" :state="false" @change="change" @input="input" :stepper="true"></datepicker>
      <!-- <b-form-input v-model="dt" type="date" v-if="editMode" style="width:175px" @input="input" @change="change"></b-form-input> -->
      <!-- <b-form-timepicker v-model="tm" locale="en" v-if="editMode" @change="change" @input="input"></b-form-timepicker> -->
      <!-- <b-form-input v-model="tm" type="time" v-if="editMode" style="width:100px" @input="input" @change="change"></b-form-input> -->
      <!-- <b-form-input v-model="tm" type="text" :state="isValid(tm)"  v-if="editMode" style="width:100px" @input="input"></b-form-input> -->
      <b-form-input v-model="tm" type="text" v-if="editMode" style="width:100px" @input="change"></b-form-input>
      
      </b-input-group>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import datepicker from "../components/datepicker.vue";

export default {
  name: "datetimepicker",
  props: { value: [String, Date], editMode: Boolean },
  components: {datepicker},
  data() {
    return {
      dt: null,
      tm: null
    };
  },
  watch: {
    value: function() {
      console.log("value changed:" + JSON.stringify(this.value));
      this.setVars();
    }
  },
  created() {
    console.log("datetimepicker created");
    console.log(this.value);
    this.setVars();
  },
  methods: {
    setVars() {
      var m = moment(String(this.value));
      this.tm = m.format("HH:mm");
      this.dt = m.format("YYYY-MM-DD");
    },
    change() {
      // var a = moment(this.dt + " " + this.tm).local();
      // this.$emit("change", a);
      var b = new Date(this.dt + " " + this.tm); //Avoid time zone problems?
      this.$emit("change", b);
    },
    input() {
      var a = moment(this.dt + " " + this.tm);

      if(a.isValid())
        this.$emit("input", a.toDate());
    },
    isValid(d) {
      var a = moment(d);
      return a.isValid();
    }

  }
};
</script>

<style>
</style>